const contactDataModalTypes = {
    CREATE_CONTACT: 'CREATE_CONTACT',
    EDIT_CONTACT: 'EDIT_CONTACT',
};

export default contactDataModalTypes;
